import { useState, useEffect, useCallback } from 'react'
import './Game.css' // Reuse the existing styles
import { gameConfig } from '../config/gameConfig'

interface GameStats {
  totalGames: number
  wins: number
  losses: number
  currentWinStreak: number
  bestWinStreak: number
  winsByPlayersRevealed: { [key: string]: number }
}

interface StatsModalProps {
  isOpen: boolean
  onClose: () => void
}

function StatsModal({ isOpen, onClose }: StatsModalProps) {
  const [stats, setStats] = useState<GameStats>({
    totalGames: 0,
    wins: 0,
    losses: 0,
    currentWinStreak: 0,
    bestWinStreak: 0,
    winsByPlayersRevealed: {}
  })

  const prefix = gameConfig.storagePrefix

  const loadGameStats = useCallback((): GameStats => {
      const STATS_KEY = `${prefix}-game-stats`
      console.log("Loading stats from", STATS_KEY)
      try {
        const saved = localStorage.getItem(STATS_KEY)
        if (saved) {
          return JSON.parse(saved)
        }
      } catch (error) {
        console.error('Error loading stats:', error)
      }

      // Default stats
      return {
        totalGames: 0,
        wins: 0,
        losses: 0,
        currentWinStreak: 0,
        bestWinStreak: 0,
        winsByPlayersRevealed: {}
      }
    }, [prefix]);

  // Load stats whenever the modal opens and refresh periodically while open
  useEffect(() => {

    if (isOpen) {
      // Load stats immediately when modal opens
      const stats = loadGameStats();
      console.log("aaa", stats)
      setStats(stats)

      // Set up an interval to refresh stats every 500ms while modal is open
      const interval = setInterval(() => {
        setStats(loadGameStats())
      }, 500)

      // Clean up interval when modal closes
      return () => clearInterval(interval)
    }
  }, [isOpen, loadGameStats])

  const winRate = stats.totalGames > 0 ? Math.round((stats.wins / stats.totalGames) * 100) : 0

  if (!isOpen) return null

  return (
    <div className="stats-modal" onClick={onClose}>
      <div className="stats-content" onClick={(e) => e.stopPropagation()}>
        <div className="stats-header">
          <h2>📊 Your Numbers</h2>
          <button onClick={onClose} className="stats-close">✕</button>
        </div>

        <div className="stats-summary">
          <div className="stat-item">
            <div className="stat-value">{stats.totalGames}</div>
            <div className="stat-label">Games Played</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{winRate}%</div>
            <div className="stat-label">Win Rate</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{stats.currentWinStreak}</div>
            <div className="stat-label">Current Streak</div>
          </div>
          <div className="stat-item">
            <div className="stat-value">{stats.bestWinStreak}</div>
            <div className="stat-label">Best Streak</div>
          </div>
        </div>

        {stats.totalGames > 0 && (
          <>
            <div className="stats-section">
              <h3>🏆 How many {gameConfig.thing} revealed in wins?</h3>
              <div className="distribution-chart">
                {Object.entries(stats.winsByPlayersRevealed).map(([players, count]) => {
                  const countNumber = typeof count === 'number' ? count : 0
                  return (
                    <div key={`win-${players}`} className="distribution-bar">
                      <span className="distribution-label">{players}</span>
                      <div className="distribution-visual">
                        <div
                          className="distribution-fill win-fill"
                          style={{ width: stats.wins > 0 ? `${(countNumber / stats.wins) * 100}%` : '0%' }}
                        ></div>
                      </div>
                      <span className="distribution-count">{countNumber}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default StatsModal
